import { IAuthState } from 'types';
import { getFromLS } from 'utils';
import { LS_KEY_ACCESS_TOKEN } from 'constants/index';

export const initState: IAuthState = {
  isAuthorized: !!getFromLS(LS_KEY_ACCESS_TOKEN),
};
